import { useCallback, useEffect, useRef, useState } from 'react';
import { assoc, dissoc, propOr } from 'ramda';

const useActionGuard = () => {
  const [loading, setLoading] = useState({});
  const pendingRef = useRef({});
  const isMountedRef = useRef(true);

  useEffect(() => () => { isMountedRef.current = false; }, []);

  const run = useCallback((key, invoke, onDone) => {
    if (propOr(false, key, pendingRef.current)) return;

    pendingRef.current = assoc(key, true, pendingRef.current);
    setLoading(assoc(key, true));

    const done = (...args) => {
      pendingRef.current = dissoc(key, pendingRef.current);
      if (isMountedRef.current) setLoading(dissoc(key));
      onDone && onDone(...args);
    };

    invoke(done);
  }, []);

  return { loading, run };
};

export default useActionGuard;
